/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sidebar_Aiinteractive1Inputs */

const zh_sidebar_aiinteractive1 = /** @type {(inputs: Sidebar_Aiinteractive1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`内容工坊`)
};

const en_sidebar_aiinteractive1 = /** @type {(inputs: Sidebar_Aiinteractive1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Content Workshop`)
};

const es_sidebar_aiinteractive1 = /** @type {(inputs: Sidebar_Aiinteractive1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taller de Contenido`)
};

/**
* | output |
* | --- |
* | "Content Workshop" |
*
* @param {Sidebar_Aiinteractive1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const sidebar_aiinteractive1 = /** @type {((inputs?: Sidebar_Aiinteractive1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_Aiinteractive1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_sidebar_aiinteractive1(inputs)
	if (locale === "en") return en_sidebar_aiinteractive1(inputs)
	return es_sidebar_aiinteractive1(inputs)
});
export { sidebar_aiinteractive1 as "sidebar_aiInteractive" }